import React from "react";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { company, navLinks, brand } from "../data/mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-black border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-4 mb-5">
              <img src={brand.logoWhite} alt="R&C" className="h-16 w-auto object-contain" />
              <div className="leading-tight border-l border-white/15 pl-4">
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/55">Public & Civil Engineers</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#F5D000]">Since 1957</div>
              </div>
            </Link>
            <p className="text-white/55 max-w-md leading-relaxed">
              Civil engineering contractors based at Spaghetti Junction, Birmingham
             , building the bridges, structures and steelworks that move Britain since {company.established}.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.3em] text-white/55 mb-5">Navigate</div>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}>
                  {l.to.startsWith("/#") ? (
                    <a href={l.to} className="text-white/75 hover:text-[#F5D000] transition-colors">
                      {l.label}
                    </a>
                  ) : (
                    <Link to={l.to} className="text-white/75 hover:text-[#F5D000] transition-colors">
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.3em] text-white/55 mb-5">Contact</div>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${company.phone}`} className="flex items-start gap-3 text-white/80 hover:text-white">
                  <Phone className="w-4 h-4 mt-1 text-[#F5D000]" />
                  <span>{company.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${company.email}`} className="flex items-start gap-3 text-white/80 hover:text-white">
                  <Mail className="w-4 h-4 mt-1 text-[#F5D000]" />
                  <span>{company.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-1 text-[#F5D000]" />
                <span>{company.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/45">
            R&amp;C, Public &amp; Civil Engineers © {year}. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-white/55 hover:text-white">Privacy Policy</a>
            <a href="#" className="text-xs text-white/55 hover:text-white">Cookies</a>
            <a href="#home" className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/70 hover:text-[#F5D000]">
              Back to top <ArrowUp className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
